import React from 'react'
import { makeStyles, Grid, Paper, Grow, Box, fade, Typography, Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useHistory, useParams } from "react-router-dom";
import Data from "../../data/data"
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { GetCitiesOfState } from '../../data/utils';
import Loader from '../../loading/index'
const useStyles = makeStyles((theme) => ({
  rootsInput: {
    flexGrow: 1,
    // width: '50%',
    alignItems: "center"

  },

  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.50),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 1),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '50ch',
      '&:focus': {
        width: '50ch',
      },
    },
  },
  box1: {
    paddingTop: "120px",
    width: "100%"
  },
  counter: {
    fontFamily: ['Open Sans', "sans-serif"],
    color: "#fff",
    background: "#fff",
    textAlign: "center",
    // width: "190px",
    padding: "25px 30px 10px",
    margin: "0 auto",
    borderRadius: "30px 0",
    boxShadow: "10px 10px 0 rgba(0,0,0,0.05)",
    position: "relative",
    zIndex: 1,
    "&:hover": {
      cursor: "pointer",
      "& :nth-child(1)": {
        transform: "rotateX(360deg)",
        textShadow: "0 0 10px rgba(0, 0, 0, 0.4)"
      },
    },
    "&::before": {
      content: '""',
      background: "#021266",
      borderRadius: "15px 0 30px 0",
      boxShadow: "inset 0 4px 8px rgba(0,0,0,0.15)",
      position: "absolute",
      top: "12px",
      left: "12px",
      right: "12px",
      bottom: "27px",
      zIndex: -1,
    },
  },
  counterIcon: {
    fontSize: "35px",
    margin: "0 0 10px",
    textShadow: "0 0 3px #FF0000, 0 0 5px #0000FF",
    transform: "rotateX(0deg)",
    transition: "all 0.3s ease 0s",
  },
  Typography: {
    fontSize: "16px",
    fontWeight: 700,
    textTransform: "uppercase",
    textShadow: "0 0 3px #FF0000, 0 0 5px #0000FF",
    letterSpacing: "1px",
    margin: "0 0 20px",
  },
  counterValue: {
    color: "#666",
    background: "#fff",
    fontSize: "33px",
    fontWeight: 600,
    textAlign: "right",
    lineHeight: "60px",
    width: "50%",
    height: "50px",
    padding: "0 15px",
    margin: "0 0 0 -20px",
    display: "block",
  },
  link: {
    textDecoration: "none"
  },
  LoadMoreCities: {
    marginTop: "2rem",
    display: "flex",
    justifyContent: "center"
  },
  loadMorebtn: {
    color: 'white',
    background: "radial-gradient(circle, rgba(255,88,5,1) 0%, rgba(7,23,142,1) 100%)"
  }
}));


export default function Cites() {

  let params = useParams()
  const [searchItem, setSearch] = React.useState('')
  const [loding, setloding] = React.useState(true)
  const [visible, setVisible] = React.useState(10)
  const { country, st, stateIndex } = params;
  const classes = useStyles();
  const UsAllcites = GetCitiesOfState(country, st)


  React.useEffect(() => {
    if (UsAllcites) {
      setloding(false)
    }
  }, [UsAllcites])


  const LoadMoreCitiesHandler = () => {
    setVisible(visible + 5)
  }



  return (

    <div style={{ backgroundColor: "#15244D" }}>
      {loding == false ? <Box className={classes.box1} width={1}>
        <Grid style={{ margin: "auto", width: "80%" }}>
          <div className={classes.rootsInput}>

            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search…"
                classes={{
                  rootsInput: classes.inputRoot,
                  input: classes.inputInput,
                }}
                inputProps={{ 'aria-label': 'search' }}
              />
            </div>

          </div>
        </Grid>
        <br />
        <Box maxWidth="1248px" mx="auto" style={{ backgroundColor: "#15244D" }} p="10px">
          <Grid container spacing={2}>
            {
              UsAllcites.slice(0, visible).filter((ite) => {
                if (searchItem == "") {
                  return ite
                } else if (ite.name.toLowerCase().includes(searchItem.toLowerCase())) {
                  return ite
                }
              }).map((item, i) =>

                < Grid item xs={12} sm={6} md={3} className={classes.link} key={i} component={Link} to={`/cites/${item.countryCode}/${item.stateCode}/${stateIndex}/${item.name}/${item.zip}`} >

                  <ScrollAnimation animateIn="zoomIn">
                    <div className={classes.counter}>
                      <div className={classes.counterIcon}>
                        <i class="fas fa-city"></i>
                      </div>
                      <h3 className={classes.h3}>{item.name}</h3>
                      <h3 className={classes.h3}>sate: {Data[stateIndex].name}</h3>
                      <h3 className={classes.h3}>Country: US</h3>
                      <h5 className={classes.h3}>Zip Code:{item.zip}</h5>
                      <span className={classes.counterValue}> <Button style={{ color: "#F5A623", fontWeight: 900, width: "100%", height: "100%", fontSize: "18px", letterSpacing: "2px" }}>
                        Details
                   </Button></span>
                    </div>
                  </ScrollAnimation>
                </Grid>
              )
            }

          </Grid>

        </Box>
      </Box> : <div style={{ backgroundColor: "#15244D", paddingTop: "8rem", height: "100vh", overflow: "hidden" }}>
        <Loader /> </div>}

      {visible < UsAllcites.length && <Container maxWidth="xs" className={classes.LoadMoreCities}>
        <Button className={classes.loadMorebtn} onClick={LoadMoreCitiesHandler} fullWidth>Load More Cities</Button>
      </Container>}
    </div>
  )
}

